export default "__VITE_ASSET__CTTLMuR5__"